module.exports = __webpack_public_path__ + "img/mount4.7a44f59e.jpg";